import "./ShowResult.css";

interface IShowResult {
  content: string;
}
const ShowResult = (props: IShowResult) => {
  const { content } = props;

  return (
    <div className="result-message">
      <p>{content}</p>
    </div>
  );
};

export default ShowResult;
